import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { ApplicationView, useApplicationView } from "@hooks/useApplicationView";

export type DemoFeatureFlagScope =
    | { kind: "workspace"; workspaceId: string }
    | { kind: "organization"; organizationId: string };

/** Ignores who is viewing; the panel adds the staff check on top. */
export function useDemoFeatureFlagScope(): DemoFeatureFlagScope | null {
    const activeWorkspace = useActiveWorkspace();
    const activeOrganization = useActiveOrganization();
    const applicationView = useApplicationView();

    if (activeWorkspace) {
        return activeWorkspace.isDemo
            ? { kind: "workspace", workspaceId: activeWorkspace.id }
            : null;
    }

    if (
        applicationView === ApplicationView.ORGANIZATION_VIEW &&
        activeOrganization?.isDemo
    ) {
        return { kind: "organization", organizationId: activeOrganization.id };
    }

    return null;
}
